var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCalendarSolid20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.5 9v7a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1V9zm-3.25-7a.75.75 0 0 1 .75.75V4h1.5a1 1 0 0 1 1 1v3h-15V5a1 1 0 0 1 1-1H5V2.75a.75.75 0 0 1 1.5 0V4h7V2.75a.75.75 0 0 1 .75-.75"
})));
export default SvgIcCalendarSolid20X20;